const DEMO_RESERVATION_CONTACT_TTL = 24 * 60 * 60 * 1000

function pruneExpiredContacts(contacts, now) {
    // 过期记录在读写缓存时顺手清理，避免 localStorage 长期堆积无效联系方式。
    Object.keys(contacts).forEach((contactKey) => {
        const entry = contacts[contactKey]
        if (!entry || entry.expiresAt <= now) {
            delete contacts[contactKey]
        }
    })
}

const officialWebsite = {
    namespaced: true,

    state() {
        return {
            // 由 vuex-persist 持久化到 localStorage，刷新页面后仍可拦截 24 小时内重复提交。
            demoReservationContacts: {},
        }
    },

    getters: {
        hasActiveDemoReservationContact: (state) => (contactKey, now = Date.now()) => {
            // 只把未过期记录视为命中，过期记录会在下一次 mutation 中被清理。
            const entry = state.demoReservationContacts[contactKey]
            return Boolean(entry && entry.expiresAt > now)
        },
    },

    mutations: {
        PRUNE_EXPIRED_DEMO_RESERVATION_CONTACTS(state, now = Date.now()) {
            pruneExpiredContacts(state.demoReservationContacts, now)
        },

        REMEMBER_DEMO_RESERVATION_CONTACT(state, { contactKey, now = Date.now() }) {
            // 缓存只保存归一化后的联系方式 key 和时间戳，不保存用户完整表单内容。
            pruneExpiredContacts(state.demoReservationContacts, now)
            state.demoReservationContacts[contactKey] = {
                cachedAt: now,
                expiresAt: now + DEMO_RESERVATION_CONTACT_TTL,
            }
        },
    },
}

export default officialWebsite
